// extracted by mini-css-extract-plugin
module.exports = {"feedback__icon":"Feedback_feedback__icon__s66LD","feedback__title":"Feedback_feedback__title__fdqRs","feedback__text":"Feedback_feedback__text__v_K_A"};